import * as yup from 'yup';
import { fieldRequired, maxLength, validEmail } from '../../../constants';

export const organizationValidation = yup.object().shape({
  orgKey: yup
    .string()
    .nullable()
    .required(fieldRequired)
    .max(100, `${maxLength} 100`),
  organizationName: yup
    .string()
    .nullable()
    .required(fieldRequired)
    .max(50, `${maxLength} 50`),
  alternateName: yup.string().nullable().max(75, `${maxLength} 75`),
  address: yup.string().nullable().max(100, `${maxLength} 100`),
  state: yup.string().nullable().max(2, `${maxLength} 2`),
  zip: yup.string().nullable().max(50, `${maxLength} 50`),
  postalAddress: yup.string().nullable().max(100, `${maxLength} 100`),
  postalCity: yup.string().nullable().max(50, `${maxLength} 50`),
  postalZip: yup.string().nullable().max(50, `${maxLength} 50`),
  commPhone: yup.string().nullable().max(20, `${maxLength} 20`),
  commFax: yup.string().nullable().max(20, `${maxLength} 20`),
  commEmail: yup
    .string()
    .nullable()
    .email(validEmail)
    .max(50, `${maxLength} 50`),
  commWeb: yup.string().nullable().max(50, `${maxLength} 50`),
  contractAgency: yup.string().nullable().max(50, `${maxLength} 50`),
  sapContract: yup.string().nullable().max(20, `${maxLength} 20`),
  sapCode: yup.string().nullable().max(20, `${maxLength} 20`),
  sapNum: yup.string().nullable().max(20, `${maxLength} 20`),
  prisonCode: yup.string().nullable().max(20, `${maxLength} 20`),
  comment: yup.string().nullable().max(800, `${maxLength} 800`),
});

export const organizationContactValidation = yup.object().shape({
  contactKey: yup
    .string()
    .nullable()
    .required(fieldRequired)
    .max(50, `${maxLength} 50`),
  honorific: yup.string().nullable().max(50, `${maxLength} 50`),
  firstName: yup.string().nullable().max(50, `${maxLength} 50`),
  suffix: yup.string().nullable().max(50, `${maxLength} 50`),
  lastName: yup.string().nullable().max(50, `${maxLength} 50`),
  title: yup.string().nullable().max(50, `${maxLength} 50`),
  workPhone: yup.string().nullable().max(20, `${maxLength} 20`),
});

export const organizationComplianceListFormValidation = yup.object().shape({
  ReferenceNumber: yup.string().nullable().max(20, `${maxLength} 20`),
  description: yup.string().nullable().max(100, `${maxLength} 100`),
});
